/**
 * Wire contract for SOW/Quote document extraction. SPEC-0006 (Draft).
 *
 * NOT approved for production customer use. This exists so the feature is
 * ready to enable once SPEC-0006's open questions 1 (legal disclosure) and 5
 * (accuracy corpus) close — see the spec. Do not surface a path that lets a
 * real customer document reach this before then.
 *
 * Every field is nullable rather than required: a value the model cannot
 * find comes back `null`, never guessed — the same principle SPEC-0004 §5
 * applies to the agent's answers. These are raw, unvalidated extraction
 * results; they pass through the same `soldRowSchema` validation as any CSV
 * row once the user confirms them, per SPEC-0006's Data section.
 */
import { SOLD_FIELDS } from './canonical.js';
/**
 * The eight sold-hours fields SPEC-0001's Data section defines (six original,
 * plus `go_live_date`/`end_date` added under SPEC-0007).
 *
 * Written as its own literal tuple, rather than derived with `.map()` from
 * `SOLD_FIELDS`, so `SoldCanonicalField` stays a precise string-literal union
 * instead of widening to `string` — but that means it can drift from
 * `SOLD_FIELDS` silently if a field is ever added or renamed there. The
 * assertion below turns that drift into an immediate failure instead.
 */
export const SOLD_CANONICAL_FIELDS = [
    'project_id',
    'client_name',
    'role',
    'sold_hours',
    'rate',
    'sow_signed_date',
    'go_live_date',
    'end_date',
];
if (SOLD_FIELDS.map((f) => f.key)
    .slice()
    .sort()
    .join(',') !==
    [...SOLD_CANONICAL_FIELDS].sort().join(',')) {
    throw new Error('SOLD_CANONICAL_FIELDS (extraction.ts) has drifted from SOLD_FIELDS (canonical.ts) — update both.');
}
/** Which of the six fields `reconcile()` actually requires, straight from the
 * one place that already knows — never a second hand-written list. */
export const SOLD_REQUIRED_CANONICAL_FIELDS = SOLD_FIELDS.filter((f) => f.required).map((f) => f.key);
//# sourceMappingURL=extraction.js.map